"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react2 = require("@emotion/react");
var _Typography = _interopRequireDefault(require("../../atoms/Typography"));
var _Row = _interopRequireDefault(require("../../layout/Row"));
var _Pricing = _interopRequireDefault(require("../../molecules/Pricing"));
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  specs: [],
  price: {}
};
function OrderItemSpecs(props) {
  const {
    specs,
    price
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const {
    colors
  } = (0, _react2.useTheme)();
  const hasPrice = (0, _react.useMemo)(() => {
    var _Object$values;
    return !!((_Object$values = Object.values(price || {})) !== null && _Object$values !== void 0 && _Object$values.length);
  }, [price]);
  return hasPrice ? /*#__PURE__*/_react.default.createElement(StyledRowPrice, {
    gap: 5
  }, /*#__PURE__*/_react.default.createElement(_Pricing.default, {
    size: 14,
    weight: 700,
    currencyCode: price === null || price === void 0 ? void 0 : price.currencyCode,
    amount: (price === null || price === void 0 ? void 0 : price.amount) || 0,
    currencySize: 10,
    color: colors === null || colors === void 0 ? void 0 : colors.FONT.HELPER
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: "description",
    children: "\u2022"
  }), /*#__PURE__*/_react.default.createElement(_Pricing.default, {
    size: 14,
    weight: 700,
    currencyCode: price === null || price === void 0 ? void 0 : price.currencyCode,
    amount: ((price === null || price === void 0 ? void 0 : price.quantity) || 0) * ((price === null || price === void 0 ? void 0 : price.amount) || 0),
    currencySize: 10,
    color: colors === null || colors === void 0 ? void 0 : colors.FONT.HELPER
  })) : /*#__PURE__*/_react.default.createElement(_Row.default, {
    gap: 0,
    align: "space-between"
  }, specs === null || specs === void 0 ? void 0 : specs.map(_ref => {
    let {
      key,
      value
    } = _ref;
    return /*#__PURE__*/_react.default.createElement(StyledTypography, {
      key: "".concat(key, "-").concat(value),
      type: "description",
      children: value,
      weight: 700,
      size: 14,
      "data-order-item-spec": value,
      afterStyles: {
        content: " ".concat(key !== null && key !== void 0 ? key : ''),
        size: 10,
        weight: 300
      }
    });
  }));
}
const StyledRowPrice = (0, _styled.default)(_Row.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  @media screen and (min-width: 768px) {\n    align-items: end;\n\n    [type='price'] {\n      font-size: 18px;\n      line-height: normal;\n\n      &::after {\n        font-size: 14px;\n      }\n    }\n  }\n"])));
const StyledTypography = (0, _styled.default)(_Typography.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  @media screen and (min-width: 768px) {\n    font-size: 18px;\n    line-height: 22px;\n\n    &::after {\n      font-size: 16px;\n    }\n  }\n"])));
var _default = exports.default = OrderItemSpecs;